export default __webpack_public_path__ + "static/media/CapaExistingGroups.f1535f7c.svg";